import React, { useState } from "react";
import {
  Container,
  Typography,
 
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,

} from "@mui/material";
import {
  Search as SearchIcon,
  
} from "@mui/icons-material";
import Layout from "../components/layout/CompliceLayout";

const generateMockAuditTrails = () => {
  const actions = [
    "Login",
    "Logout",
    "Create Invoice",
    "Update Financial Record",
    "Generate Report",
    "Delete Transaction",
    "Export Data",
  ];
  const users = ["John Doe", "Jane Smith", "Admin User", "Financial Analyst"];
  const statuses = ["Success", "Warning", "Error"];

  return Array.from({ length: 50 }, (_, index) => ({
    id: `AT-${1000 + index}`,
    timestamp: new Date(
      2024,
      0,
      index + 1,
      Math.floor(Math.random() * 24),
      Math.floor(Math.random() * 60)
    ),
    user: users[Math.floor(Math.random() * users.length)],
    action: actions[Math.floor(Math.random() * actions.length)],
    status: statuses[Math.floor(Math.random() * statuses.length)],
    ipAddress: `192.168.1.${Math.floor(Math.random() * 255)}`,
  }));
};

const AuditTrailsPage = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterUser, setFilterUser] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  // Generate mock data
  const auditTrails = generateMockAuditTrails();

  // Filter and paginate audit trails
  const filteredAuditTrails = auditTrails.filter(
    (trail) =>
      (searchTerm
        ? trail.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
          trail.id.toLowerCase().includes(searchTerm.toLowerCase())
        : true) &&
      (filterUser ? trail.user === filterUser : true) &&
      (filterStatus ? trail.status === filterStatus : true)
  );

  const paginatedAuditTrails = filteredAuditTrails.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Success":
        return "success";
      case "Warning":
        return "warning";
      case "Error":
        return "error";
      default:
        return "default";
    }
  };
  return (
    <Layout>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Audit Trails
        </Typography>

        {/* Filters and Search */}
        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
          <TextField
            fullWidth
            variant="outlined"
            label="Search Audit Trails"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
          />

          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Filter by User</InputLabel>
            <Select
              value={filterUser}
              label="Filter by User"
              onChange={(e) => setFilterUser(e.target.value)}
            >
              <MenuItem value="">All Users</MenuItem>
              {[...new Set(auditTrails.map((trail) => trail.user))].map(
                (user) => (
                  <MenuItem key={user} value={user}>
                    {user}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Filter by Status</InputLabel>
            <Select
              value={filterStatus}
              label="Filter by Status"
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <MenuItem value="">All Statuses</MenuItem>
              <MenuItem value="Success">Success</MenuItem>
              <MenuItem value="Warning">Warning</MenuItem>
              <MenuItem value="Error">Error</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Audit Trails Table */}
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Audit Trail ID</TableCell>
                  <TableCell>Timestamp</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>IP Address</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedAuditTrails.map((trail) => (
                  <TableRow key={trail.id}>
                    <TableCell>{trail.id}</TableCell>
                    <TableCell>{trail.timestamp.toLocaleString()}</TableCell>
                    <TableCell>{trail.user}</TableCell>
                    <TableCell>{trail.action}</TableCell>
                    <TableCell>
                      <Chip
                        label={trail.status}
                        color={getStatusColor(trail.status)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{trail.ipAddress}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredAuditTrails.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Container>
    </Layout>
  );
};

export default AuditTrailsPage;
